import React from 'react'
import { SVGProps } from 'react'

const ExitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M9.9999 9.16678C9.63125 9.16678 9.33328 9.46548 9.33328 9.8334V12.5001C9.33328 12.8674 9.03457 13.1667 8.66654 13.1667H6.66656V3.16684C6.66656 2.59751 6.30389 2.08885 5.75861 1.89952L5.56122 1.83348H8.66654C9.03457 1.83348 9.33328 2.1328 9.33328 2.50022V4.5002C9.33328 4.86812 9.63125 5.16682 9.9999 5.16682C10.3685 5.16682 10.6665 4.86812 10.6665 4.5002V2.50022C10.6665 1.39757 9.76919 0.500244 8.66654 0.500244H1.49998C1.47459 0.500244 1.45335 0.511597 1.4287 0.514892C1.39659 0.512207 1.36595 0.500244 1.33336 0.500244C0.598016 0.500244 0 1.09814 0 1.83348V13.8334C0 14.4027 0.362667 14.9113 0.907949 15.1007L4.91999 16.4381C5.05598 16.4801 5.19123 16.5001 5.33332 16.5001C6.06866 16.5001 6.66656 15.9021 6.66656 15.1667V14.5001H8.66654C9.76919 14.5001 10.6665 13.6028 10.6665 12.5001V9.8334C10.6665 9.46548 10.3685 9.16678 9.9999 9.16678Z" />
      <path d="M15.8045 6.69536L13.1378 4.02876C12.9472 3.83809 12.6605 3.78072 12.4112 3.88399C12.1626 3.98738 11.9998 4.23067 11.9998 4.50007V6.50005H9.33324C8.96521 6.50005 8.6665 6.79863 8.6665 7.16667C8.6665 7.53471 8.96521 7.83329 9.33324 7.83329H11.9998V9.83327C11.9998 10.1027 12.1626 10.346 12.4112 10.4494C12.6605 10.5526 12.9472 10.4952 13.1378 10.3047L15.8045 7.63798C16.0651 7.37736 16.0651 6.95598 15.8045 6.69536Z" />
    </g>
  </svg>
)
export default ExitIcon
